var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import to from 'await-to-js';
export * from './Types';
export function trackView(host, affiliateId, target) {
    return __awaiter(this, void 0, void 0, function* () {
        track(host, affiliateId, '/.crm/banner/view', target);
    });
}
export function trackLoad(host, affiliateId, target) {
    return __awaiter(this, void 0, void 0, function* () {
        track(host, affiliateId, '/.crm/banner/load', target);
    });
}
export function trackClick(host, affiliateId, target) {
    return __awaiter(this, void 0, void 0, function* () {
        track(host, affiliateId, '/.crm/banner/click', target);
    });
}
function track(host, affiliateId, path, target) {
    try {
        let source;
        try {
            source = new URL(document.referrer).origin;
        }
        catch (e) {
            source = window.location.origin;
        }
        const partnerId = affiliateId.split('-')[0];
        let mui = undefined;
        if (partnerId) {
            try {
                const muiCookie = document.cookie
                    .split(';')
                    .map(row => row.trim())
                    .find(row => row.startsWith('MUI='));
                const raw = muiCookie === null || muiCookie === void 0 ? void 0 : muiCookie.split('=').slice(1).join('=');
                const list = raw ? JSON.parse(decodeURIComponent(raw)) : [];
                const hadPartnerId = list.includes(partnerId);
                mui = !hadPartnerId;
                const newList = hadPartnerId ? list : [...list, partnerId];
                const endOfMonth = new Date();
                endOfMonth.setMonth(endOfMonth.getMonth() + 1, 0);
                endOfMonth.setHours(23, 59, 59, 999);
                document.cookie = `MUI=${encodeURIComponent(JSON.stringify(newList))}; expires=${endOfMonth.toUTCString()}; path=/; SameSite=None; Secure`;
            }
            catch (e) {
                mui = undefined;
            }
        }
        const data = {
            affiliateId: affiliateId,
            referrer: source,
            userToken: 'UNKNOWN',
            mui
        };
        return to(fetch(`${host}${path}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(data)
        }).then((response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.ok) {
                throw new Error(yield response.text());
            }
            return response;
        })));
    }
    catch (e) {
        console.error(e);
    }
}
//# sourceMappingURL=index.js.map